import { css, keyframes } from '@emotion/react';

export const flashStyle = css({
	animation: keyframes`
	0% {
		opacity: .2;
	}
	50% {
		opacity: 1;
	}
	`,
	animationDuration: '0.5s',
	animationDirection: 'alternate',
	animationIterationCount: 'infinite',
	animationTimingFunction: 'ease-in-out'
});
